/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const GlobalErrorPageWrapper = styled.div({
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  color: token('color.text.subtle'),
});

export const Center = styled.div({
  textAlign: 'center',
  width: `${gridSize() * 40}px`,
});

export const ErrorImage = styled.div({
  width: `${gridSize() * 10}px`,
  margin: 'auto',
});
